import Yup, { globalValidations } from "@utils/yup";

const {
  phoneValidator,
  emailValidator,
  nidValidator,
  birthDate,
  passwordValidator,
  string,
} = globalValidations;

export const RegisterSchema = Yup.object().shape({
  phone: phoneValidator,
  email: emailValidator,
  nin: nidValidator,
  birth_date: birthDate,
  password: passwordValidator,
  phone_country_iso2: string,
  confirmed: Yup.boolean().required(),
});
